import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';

const UniDayMc = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>UniDayMc - Cliccami.net</title>
        <meta
          name="description"
          content="Il mondo universitario a portata di clic. Offerte, servizi e iniziative per studenti e docenti a Macerata."
        />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header onFilterClick={() => {}} />

        {/* Linea divisoria sottile */}
        <div className="w-full border-t border-gray-300"></div>

        {/* Contenuto principale */}
        <section className="py-16 md:py-24 bg-white">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            {/* Logo UniDayMc */}
            <div className="mb-8 flex justify-center">
              <div className="bg-white p-6 rounded-lg shadow-lg">
                <img
                  src="/assets/images/LG1-1771071233570.png"
                  alt="UniDayMc - Logo"
                  className="w-full h-auto object-contain"
                  style={{ maxWidth: '300px', maxHeight: '200px' }}
                />
              </div>
            </div>

            {/* Titolo */}
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              UniDayMc
            </h1>

            {/* Sottotitolo */}
            <p className="text-2xl md:text-3xl text-gray-600 font-medium mb-8">
              Sezione in arrivo
            </p>

            {/* Descrizione */}
            <p className="text-lg text-gray-700 leading-relaxed mb-12 max-w-2xl mx-auto">
              Stiamo preparando contenuti esclusivi per studenti e docenti dell'Università di Macerata.
              Convenzioni, offerte e opportunità dedicate al mondo universitario.
            </p>

            {/* Pulsante Torna ai Servizi */}
            <button
              onClick={() => navigate('/home-servizi')}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-4 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105"
            >
              Torna ai Servizi
            </button>
          </div>
        </section>
      </div>
    </>
  );
};

export default UniDayMc;